import { useState, useEffect } from 'react';
import {
  ButtonPrimary,
  ButtonPseudo,
  Select,
  SidePanel,
  SidePanelType,
} from '@ui/src';
import { useAppSelector } from '@store';
import { TariffStatus } from '../../hoc/tariffs/types';
import { ArchiveSidepanelTypes } from './types';

import cn from './tariffs.module.css';

const ArchiveSidepanel = ({
  panelIsOpen,
  setPanelIsOpen,
  status,
  onStatusChange,
  statusChangeInProgress,
  statusChangeSuccess,
  tariffId,
}: ArchiveSidepanelTypes) => {
  const [selectedTariff, setSelectedTariff] = useState('');

  const {
    tariffs: {
      tariffPage: { tariffs },
      list: { tariffs: tariffsList },
    },
    configurationDictionaries: { riskScoreRanges },
  } = useAppSelector((state) => state);

  useEffect(() => {
    if (statusChangeSuccess) {
      setPanelIsOpen(false);
      setSelectedTariff('');
    }
  }, [statusChangeSuccess]);

  return (
    <SidePanel
      type={SidePanelType.Fees}
      closeOnClickOutside
      isOpen={panelIsOpen}
      onClose={() => setPanelIsOpen(false)}
      title="Archive tariff"
      sidepanelExpandedKey="archive-tariff"
      footer={
        <>
          <ButtonPrimary
            text={statusChangeInProgress ? 'Loading...' : 'Archive tariff'}
            onClick={() =>
              onStatusChange({
                status,
                nextTariffId: selectedTariff,
              })
            }
            disabled={!selectedTariff}
            bold
          />
          <ButtonPseudo
            text="Close"
            onClick={() => setPanelIsOpen(false)}
            bold
          />
        </>
      }
    >
      <div className={cn.sidepanelSelectWrapper}>
        <div className={cn.sidepanelSelectTitle}>
          Choose a replacement tariff
        </div>
        <Select
          list={
            tariffs
              ?.filter((item) => item.value !== tariffId)
              .map((item) => {
                const body: {
                  name: string;
                  value: string;
                  description?: string;
                } = {
                  name: item.name,
                  value: item.value as string,
                };

                const currentRiskScore = riskScoreRanges?.find(
                  (range) => range.id === item.description,
                );

                if (currentRiskScore) {
                  body.description = `Risk score ${currentRiskScore.rangeStart} - ${currentRiskScore.rangeEnd} (${currentRiskScore.name})`;
                }

                return body;
              }) ||
            tariffsList
              ?.filter(
                (item) =>
                  item.status !== TariffStatus.DRAFT &&
                  item.status !== TariffStatus.ARCHIVED,
              )
              .filter((item) => item.id !== tariffId)
              .map((item) => {
                const body: {
                  name: string;
                  value: string;
                  description?: string;
                } = {
                  name: item.name,
                  value: item.id,
                };

                const currentRiskScore = riskScoreRanges?.find(
                  (range) => range.id === item.riskScoreRangeId,
                );

                if (currentRiskScore) {
                  body.description = `Risk score ${currentRiskScore.rangeStart} - ${currentRiskScore.rangeEnd} (${currentRiskScore.name})`;
                }

                return body;
              })
          }
          placeholder="Select tariff..."
          name="selectedTariff"
          value={selectedTariff}
          onChange={(e) => setSelectedTariff(e.target.value as string)}
        />
      </div>
    </SidePanel>
  );
};

export default ArchiveSidepanel;
